import CropOptions from "./cropOptions";

export const ConvertCropNameToKey = (dictionary, cropName) => {
    
    return dictionary ? Object.keys(dictionary).find(key => key.toLowerCase() === cropName) : null;
}

export const ConvertCropNameToTitle = (cropName) => {

    return CropOptions.find(cropOption => cropOption.cropType === cropName)?.title;
}